export var AIR_PLAY_PLUGIN_ID="@dicetechnology/doris-plugin-air-play";